module.exports = __webpack_public_path__ + "img/supplier-005.aca52627.png";